import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Stepper,
    Step,
    StepLabel,
    StepContent,
    Button,
    Paper,
    Typography,
    ButtonGroup,
    TextField,
    FormControlLabel,
    Radio,
    RadioGroup,
    FormControl,
    FormLabel,
    Grid
} from "@material-ui/core";
import TreatmentTable from "./TreatmentTable.js";
import CourseTable from "./CourseTable.js";
import WeekTable from "./WeekTable.js";
import DateTable from "./DateTable.js";
import queryString from "query-string";
import API from "../../actions";
import moment from "moment";
import update from "immutability-helper";
import FindClient from "../../components/Frequents/FindClient";
const useStyles = makeStyles(theme => ({
    root: {
        width: "100%"
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1)
    },
    actionsContainer: {
        marginBottom: theme.spacing(2)
    },
    resetContainer: {
        padding: theme.spacing(3)
    }
}));

const GetStepContent = props => {
    const classes = useStyles();
    //const [clientState, setClientState] = useState('eksisterende');
    const [clientArray, setClientArray] = useState([]);
    const get4lastDigitCPR = async () => {
        var result = await API.get4LastDigitCPR();
        if (result) {
            props.clientChange(update(props.client, { CPRLast4Digit: { $set: result.lastDigit } }));
        }
    };
    switch (props.step) {
        case 0:
            return (
                <>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={props.handleRegularBooking}
                        className={classes.button}>
                        Behandling
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={props.handleCourseBooking}
                        className={classes.button}>
                        Kursus
                    </Button>
                </>
            );
        case 1:
            return (
                <>
                    <FormControl component="fieldset">
                        <RadioGroup
                            row
                            aria-label="klient"
                            defaultValue="eksisterende"
                            name="klient"
                            onChange={async event => {
                                props.clientChange(update(props.client, { clientState: { $set: event.target.value } }));
                                props.removeSetMissingInfo("");
                            }}>
                            <FormControlLabel value="ny" control={<Radio color="primary" />} label="Ny klient" />
                            <FormControlLabel
                                value="eksisterende"
                                control={<Radio color="primary" />}
                                label="Eksisterende klient"
                            />
                        </RadioGroup>
                    </FormControl>

                    {props.client.clientState === "eksisterende" ? (
                        <FindClient
                            clients={clientArray}
                            journals={false}
                            changeValue={value => {
                                props.clientChange({
                                    clientId: value.id,
                                    nameFirst: value.nameFirst,
                                    nameLast: value.nameLast,
                                    email: value.email,
                                    phonePrivate: value.phonePrivate,
                                    CPR: value.CPR,
                                    CPR6Digit: value.CPR6Digit,
                                    CPRLast4Digit: value.CPRLast4Digit,
                                    clientState: "eksisterende"
                                });
                            }}
                            changeText={async event => {
                                var CPR = event.target.value;
                                if (CPR && CPR.length > 5) {
                                    CPR = CPR.trim().replace("-", "");
                                    let therapistId = props.therapistId;
                                    var clients = await API.getClientsFromTherapistCompanyOnlineBooking(
                                        therapistId,
                                        CPR
                                    );
                                    if (clients) {
                                        setClientArray(clients);
                                    }
                                }
                            }}
                        />
                    ) : (
                        <> </>
                    )}
                    {props.missingInfo !== "" ? (
                        <Typography color="secondary">* {props.missingInfo} </Typography>
                    ) : (
                        <></>
                    )}
                </>
            );
        case 2:
            return (
                <div style={{ display: "flex", flexDirection: "column" }}>
                    {props.treatmentBooking && (
                        <TextField
                            key="reason1"
                            label="Årsag til henvendelse"
                            value={props.client.reason}
                            required
                            onChange={event =>
                                // props.clientChange({
                                //     nameFirst: props.client.nameFirst,
                                //     nameLast: props.client.nameLast,
                                //     email: props.client.email,
                                //     phonePrivate: props.client.phonePrivate,
                                //     control: props.client.control,
                                //     reason: event.target.value
                                // })
                                props.clientChange(update(props.client, { reason: { $set: event.target.value } }))
                            }
                        />
                    )}
                    <TextField
                        key="firstname"
                        required
                        value={props.client.nameFirst}
                        label="Fornavn"
                        onChange={event =>
                            props.clientChange(update(props.client, { nameFirst: { $set: event.target.value } }))
                        }
                        InputProps={{
                            readOnly: props.client.clientId !== ""
                        }}
                    />
                    <TextField
                        key="lastname"
                        label="Efternavn"
                        value={props.client.nameLast}
                        required
                        onChange={event =>
                            props.clientChange(update(props.client, { nameLast: { $set: event.target.value } }))
                        }
                        InputProps={{
                            readOnly: props.client.clientId !== ""
                        }}
                    />
                    <TextField
                        key="email"
                        label="Email"
                        value={props.client.email}
                        required
                        onChange={event =>
                            props.clientChange(update(props.client, { email: { $set: event.target.value } }))
                        }
                        InputProps={{
                            readOnly: props.client.clientId !== ""
                        }}
                    />
                    <TextField
                        key="phonePrivate"
                        label="Telefonnummer"
                        value={props.client.phonePrivate}
                        required
                        onChange={event =>
                            props.clientChange(update(props.client, { phonePrivate: { $set: event.target.value } }))
                        }
                        InputProps={{
                            readOnly: props.client.clientId !== ""
                        }}
                    />
                    <TextField
                        key="CPR6Digit"
                        label="Fødselsdag"
                        value={props.client.CPR6Digit}
                        required
                        onChange={event => {
                            let val = event.target.value.replace(/\D/g, "").slice(0, 10);
                            props.clientChange(update(props.client, { CPR6Digit: { $set: val } }));
                        }}
                        inputProps={{
                            minLength: 6,
                            maxLength: 6,
                            readOnly: props.client.clientId !== ""
                        }}
                    />

                    <TextField
                        key="CPRLast4Digit"
                        label="De sidste 4 cifre i dit CPR nr"
                        value={props.client.CPRLast4Digit}
                        required
                        onChange={event => {
                            let val = event.target.value.replace(/ /g, "").slice(0, 4);
                            props.clientChange(update(props.client, { CPRLast4Digit: { $set: val } }));
                        }}
                        inputProps={{
                            minLength: 4,
                            maxLength: 4,
                            readOnly: props.client.clientId !== ""
                        }}
                    />
                    <Typography color="textSecondary">
                        <br></br>
                        {/* Du kan vælge at indtaste de 4 sidste cifre fra dit CPRnummer.
                    <br></br> */}
                    </Typography>
                    {false && props.client.clientId === "" ? (
                        <Grid item sm={3} style={{ width: "100%" }}>
                            <Button
                                variant="contained"
                                onClick={get4lastDigitCPR}
                                style={{ margin: "10px 0 10px 0", fontFamily: "Lato" }}>
                                Generer unik kode
                            </Button>
                        </Grid>
                    ) : (
                        <></>
                    )}
                    <FormControlLabel
                        data-testid="radio-element"
                        control={<Radio checked={props.client.control} />}
                        label={
                            "Jeg giver hermed tilladelse til at " +
                            (props.therapist || "qwe").companyName +
                            " må indsamle og opbevare mine data i henhold til gældende regler, og sende en sms-påmindelse før aftalen."
                        }
                        onChange={event =>
                            props.clientChange(update(props.client, { control: { $set: event.target.checked } }))
                        }
                    />
                    {props.missingInfo !== "" ? (
                        <Typography color="secondary">* {props.missingInfo} </Typography>
                    ) : (
                        <></>
                    )}
                </div>
            );
        case 3:
            if (props.treatmentBooking)
                return (
                    <TreatmentTable
                        therapist={props.therapist}
                        therapistId={props.allIds}
                        onClick={props.handleBooking}
                        clientId={props.client.clientId}
                    />
                );
            return <CourseTable therapistId={props.allIds} onClick={props.handleCourse} />;
        case 4:
            return (
                <>
                    {props.treatmentBooking ? (
                        <>
                            <div style={{ display: "flex", justifyContent: "space-between", padding: "15px 0 15px 0" }}>
                                <Typography variant="h6" gutterBottom>
                                    Uge {moment(props.date).weeks()}
                                </Typography>
                                <ButtonGroup disableElevation variant="contained" color="primary">
                                    <Button onClick={props.previousWeek}> Forrige uge</Button>
                                    <Button onClick={props.nextWeek}>Næste uge</Button>
                                </ButtonGroup>
                            </div>
                            <WeekTable
                                handleTimeClick={(time, date, i) => {
                                    props.handleTimeClick(time, date, i);
                                    // props.handleNext();
                                }}
                                treatment={props.treatment}
                                date={props.date}
                            />
                        </>
                    ) : (
                        <>
                            <p>Vælg Datoer</p>
                            <DateTable
                                course={props.course}
                                handleCourseDateClick={props.handleCourseDateClick}
                                handleBack={props.handleBack}
                                handleNext={props.handleNext}
                            />
                        </>
                    )}
                    {props.missingInfo !== "" ? (
                        <Typography color="secondary">* {props.missingInfo} </Typography>
                    ) : (
                        <></>
                    )}
                </>
            );
        default:
            return "Unknown step";
    }
};

export default props => {
    const therapistId = queryString.parse(props.location.search).therapistId;
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const [isProcessing, setIsProcessing] = useState(false);
    const [missingInfo, setMissingInfo] = useState("");
    const [treatmentBooking, setTreatmentBooking] = useState(true);
    const [date, setDate] = useState(moment().weekday(0).format("YYYY-MM-DD"));
    const [treatment, setTreatment] = useState("");
    const [weekday, setWeekday] = useState("");
    const [startTime, setStartTime] = useState("");
    const [course, setCourse] = useState("");
    const [client, setClient] = useState({
        clientId: "",
        nameFirst: "",
        nameLast: "",
        email: "",
        phonePrivate: "",
        CPR: "",
        control: false,
        reason: "",
        CPR6Digit: "",
        CPRLast4Digit: "",
        clientState: "eksisterende"
    });
    const [courseDateIds, setCourseDateIds] = useState("");
    const [therapist, setTherapist] = useState("");
    const [allIds, setAllIds] = useState("");
    const [bookText, setbookText] = useState("Book");
    const steps = [
        "Vælg type af booking",
        "Ny eller eksisterende klient?",
        "Udfyld information",
        "Vælg ydelse",
        "Book tid"
    ];
    const [selectedDate, setSelectedDate] = useState(new Date(date));

    useEffect(() => {
        setbookText("Book");
        if (!treatmentBooking) {
            if (course && course.dates && course.dates.length > 0) {
                course.dates.forEach(row => {
                    if (courseDateIds && courseDateIds.length > 0) {
                        let selected = courseDateIds.find(id => id === row.id);
                        if (selected && selected.length > 0) {
                            if (row.clients >= course.limit) {
                                setbookText("Kom på ventelisten");
                            }
                        }
                    }
                });
            }
        }
    }, [course, courseDateIds]);
    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((label, index) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                        <StepContent>
                            <GetStepContent
                                therapistId={therapistId}
                                course={course}
                                missingInfo={missingInfo}
                                handleBack={() => setActiveStep(index - 1)}
                                handleNext={() => setActiveStep(index + 1)}
                                handleTimeClick={(time, date, i) => {
                                    setStartTime(time);
                                    setSelectedDate(date);
                                    setWeekday(i);
                                }}
                                handleCourseDateClick={setCourseDateIds}
                                treatment={treatment}
                                date={date}
                                nextWeek={() => setDate(moment(date).add(7, "days").format("YYYY-MM-DD"))}
                                previousWeek={() => setDate(moment(date).subtract(7, "days").format("YYYY-MM-DD"))}
                                allIds={allIds}
                                step={index}
                                therapist={therapist}
                                treatmentBooking={treatmentBooking}
                                handleRegularBooking={async () => {
                                    setTreatmentBooking(true);
                                    setbookText("Book");
                                    const t = await API.clientGetTherapistInfo(therapistId);
                                    if (!t.isDisabled) {
                                        setAllIds(JSON.parse(t.friends || "[]").concat(therapistId));
                                        setTherapist(t);
                                        setActiveStep(index + 1);
                                    } else {
                                        alert("Bookingformular er deaktiveret");
                                    }
                                }}
                                handleCourseBooking={async () => {
                                    setTreatmentBooking(false);
                                    setbookText("Book");
                                    const t = await API.clientGetTherapistInfo(therapistId);
                                    if (!t.isDisabled) {
                                        setAllIds(JSON.parse(t.friends || "[]").concat(therapistId));
                                        setTherapist(t);
                                        setActiveStep(index + 1);
                                    } else {
                                        alert("Bookingformular er deaktiveret");
                                    }
                                }}
                                handleBooking={i => {
                                    setTreatment(i);
                                    setActiveStep(index + 1);
                                }}
                                handleCourse={i => {
                                    setCourse(i);
                                    setActiveStep(index + 1);
                                }}
                                client={client}
                                clientChange={value => {
                                    setClient(value);
                                }}
                                removeSetMissingInfo={value => {
                                    setMissingInfo(value);
                                }}
                            />
                            <div className={classes.actionsContainer}>
                                <div>
                                    {index !== 0 && !isProcessing /*&& (index !== 2 || treatmentBooking)*/ && (
                                        <Button
                                            disabled={activeStep === 0}
                                            onClick={() => {
                                                if (index === 2) {
                                                    setClient({
                                                        clientId: "",
                                                        nameFirst: "",
                                                        nameLast: "",
                                                        email: "",
                                                        phonePrivate: "",
                                                        CPR: "",
                                                        control: false,
                                                        reason: "",
                                                        CPR6Digit: "",
                                                        CPRLast4Digit: "",
                                                        clientState: "eksisterende"
                                                    });
                                                }
                                                setActiveStep(index - 1);
                                                setMissingInfo("");
                                            }}
                                            className={classes.button}>
                                            Tilbage
                                        </Button>
                                    )}
                                    {(index === 1 || index === 2) && (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={async () => {
                                                let isValid = true;
                                                if (index === 1) {
                                                    if (
                                                        client.clientId === "" &&
                                                        client.clientState === "eksisterende"
                                                    ) {
                                                        isValid = false;
                                                        setMissingInfo("Du mangler at opgive obligatorisk information");
                                                    } else {
                                                        setMissingInfo("");
                                                    }
                                                    if (treatmentBooking) {
                                                        let rows = await API.clientGetTreatmentsFromTherapist(
                                                            therapistId,
                                                            client.clientId
                                                        );
                                                        if (!rows || rows.length === 0) {
                                                            isValid = false;
                                                            setMissingInfo(
                                                                `Klinikken kan desværre ikke tage nye klienter lige nu. Kontakt os venligst på ${therapist.companyEmail} eller telefonnummer ${therapist.companyPhone} for at høre, hvornår det er muligt at få en tid.`
                                                            );
                                                        }
                                                    }
                                                } else if (index === 2) {
                                                    const mailFormat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
                                                    const phoneFormat = /^\+*\d{8,}$/;
                                                    if (
                                                        client.control &&
                                                        ((client.reason && client.reason !== "") ||
                                                            !treatmentBooking) &&
                                                        (client.clientId !== "" ||
                                                            (client.nameFirst !== "" &&
                                                                client.nameLast !== "" &&
                                                                client.CPR6Digit &&
                                                                client.CPR6Digit.length == 6 &&
                                                                client.CPRLast4Digit &&
                                                                client.CPRLast4Digit.length == 4 &&
                                                                client.email.match(mailFormat) &&
                                                                client.phonePrivate.match(phoneFormat)))
                                                    ) {
                                                        isValid = true;
                                                    } else {
                                                        isValid = false;
                                                        if (client.email !== "" && !client.email.match(mailFormat)) {
                                                            setMissingInfo("Invalid email adresse");
                                                        } else if (
                                                            client.phonePrivate &&
                                                            client.phonePrivate !== "" &&
                                                            !client.phonePrivate.replace(/\s/g, "").match(phoneFormat)
                                                        ) {
                                                            setMissingInfo(
                                                                "Telefonnummer skal være mindst 8 cifre og må ikke indeholde specialtegn udover +"
                                                            );
                                                        } else if (client.CPR6Digit && client.CPR6Digit.length < 6) {
                                                            setMissingInfo("Fødselsdag skal være 6 cifre.");
                                                        } else if (
                                                            client.CPRLast4Digit &&
                                                            client.CPRLast4Digit.length < 4
                                                        ) {
                                                            setMissingInfo(
                                                                "De sidste 4 cifre i dit CPR nr skal bestå af 4 tegn."
                                                            );
                                                        } else {
                                                            setMissingInfo(
                                                                "Du mangler at opgive obligatorisk information"
                                                            );
                                                        }
                                                    }
                                                }
                                                if (isValid) {
                                                    setMissingInfo("");
                                                    setActiveStep(index + 1);
                                                }
                                            }}
                                            className={classes.button}>
                                            Næste
                                        </Button>
                                    )}
                                    {activeStep === steps.length - 1 && !isProcessing && (
                                        <Button
                                            key="bookingbutton"
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                const mailFormat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
                                                const phoneFormat = /^\+*\d{8,}$/;

                                                // const from = moment(
                                                //     moment(date).add(weekday, "days").format("YYYY-MM-DDT") + startTime
                                                // );
                                                //     .utc()
                                                //     .valueOf();

                                                // console.log(from, "from");

                                                // const to = moment(
                                                //     moment(date).add(weekday, "days").format("YYYY-MM-DDT") + startTime
                                                // );
                                                //     .utc()
                                                //     .valueOf() +
                                                // treatment.duration * 1000;
                                                const durationInSeconds = treatment.duration; // e.g. 3600

                                                // Combine date and time into one ISO string
                                                const dateTimeString = moment(
                                                    moment(selectedDate).format("YYYY-MM-DDT") + startTime
                                                ).valueOf();
                                                // Create moment objects
                                                const from = moment.utc(dateTimeString).valueOf();
                                                const to = from + durationInSeconds * 1000;

                                                if (
                                                    client.control &&
                                                    ((client.reason && client.reason !== "") || !treatmentBooking) &&
                                                    (client.clientId !== "" ||
                                                        (client.nameFirst !== "" &&
                                                            client.nameLast !== "" &&
                                                            client.CPR6Digit &&
                                                            client.CPR6Digit.length == 6 &&
                                                            client.CPRLast4Digit &&
                                                            client.CPRLast4Digit.length == 4 &&
                                                            client.email.match(mailFormat) &&
                                                            client.phonePrivate &&
                                                            client.phonePrivate.replace(/\s/g, "").match(phoneFormat)))
                                                ) {
                                                    let isValid = false;
                                                    setIsProcessing(true);
                                                    if (treatmentBooking) {
                                                        console.log(from, "from");
                                                        console.log(to, "to");

                                                        if (from && to) {
                                                            API.clientAddBooking({
                                                                clientId: client.clientId,
                                                                nameFirst: client.nameFirst,
                                                                nameLast: client.nameLast,
                                                                email: client.email,
                                                                phonePrivate: client.phonePrivate,
                                                                CPR: client.CPR6Digit + client.CPRLast4Digit,
                                                                CPR6Digit: client.CPR6Digit,
                                                                CPRLast4Digit: client.CPRLast4Digit,
                                                                from: from, //moment(moment(date).add(weekday, "days").format("YYYY-MM-DDT") + startTime).utc().valueOf(),
                                                                to: to, //moment(moment(date).add(weekday, "days").format("YYYY-MM-DDT") + startTime).utc().valueOf() + treatment.duration * 1000,
                                                                treatmentId: treatment.id,
                                                                therapistId: treatment.therapistId,
                                                                reason: client.reason
                                                            }).then(
                                                                success => {
                                                                    setClient({
                                                                        clientId: "",
                                                                        nameFirst: "",
                                                                        nameLast: "",
                                                                        email: "",
                                                                        phonePrivate: "",
                                                                        CPR: "",
                                                                        control: false,
                                                                        reason: "",
                                                                        CPR6Digit: "",
                                                                        CPRLast4Digit: "",
                                                                        clientState: "eksisterende"
                                                                    });
                                                                    setIsProcessing(false);
                                                                    setActiveStep(5);
                                                                    isValid = true;
                                                                },
                                                                err => {
                                                                    //setbookText("Book");
                                                                    setIsProcessing(false);
                                                                    let mess =
                                                                        "Du mangler at opgive obligatorisk information";
                                                                    if (
                                                                        err ===
                                                                            "Denne klient eksisterer allerede i din klinik" ||
                                                                        err ===
                                                                            "Du kan kun bestille tider i morgen og frem. Hvis du har brug for at booke til i dag, bedes du kontakte klinikken for at aftale en tid."
                                                                    ) {
                                                                        mess = err;
                                                                    }
                                                                    setMissingInfo(mess);
                                                                    setActiveStep(4);
                                                                }
                                                            );
                                                        } else {
                                                            setIsProcessing(false);
                                                            setMissingInfo(
                                                                "Du mangler at opgive obligatorisk information"
                                                            );
                                                        }
                                                    } else {
                                                        if (courseDateIds && courseDateIds.length > 0) {
                                                            API.clientAddEventDateClients(
                                                                client.nameFirst,
                                                                client.nameLast,
                                                                client.email,
                                                                client.phonePrivate,
                                                                client.CPR6Digit + client.CPRLast4Digit,
                                                                courseDateIds,
                                                                course,
                                                                client.CPR6Digit,
                                                                client.CPRLast4Digit,
                                                                client.clientId
                                                            ).then(
                                                                success => {
                                                                    setIsProcessing(false);
                                                                    setClient({
                                                                        clientId: "",
                                                                        nameFirst: "",
                                                                        nameLast: "",
                                                                        email: "",
                                                                        phonePrivate: "",
                                                                        CPR: "",
                                                                        control: false,
                                                                        reason: "",
                                                                        CPR6Digit: "",
                                                                        CPRLast4Digit: "",
                                                                        clientState: "eksisterende"
                                                                    });
                                                                    setCourseDateIds([]);
                                                                    setActiveStep(5);
                                                                    isValid = true;
                                                                    setMissingInfo("");
                                                                },
                                                                err => {
                                                                    setIsProcessing(false);
                                                                    let mess =
                                                                        "Du mangler at opgive obligatorisk information";
                                                                    if (
                                                                        err ===
                                                                        "Denne klient eksisterer allerede i din klinik"
                                                                    ) {
                                                                        mess = err;
                                                                    }
                                                                    setMissingInfo(mess);
                                                                    setActiveStep(4);
                                                                }
                                                            );
                                                        } else {
                                                            setIsProcessing(false);
                                                            setMissingInfo(
                                                                "Du mangler at opgive obligatorisk information"
                                                            );
                                                        }
                                                    }
                                                } else {
                                                    if (client.email !== "" && !client.email.match(mailFormat)) {
                                                        setMissingInfo("Invalid email adresse");
                                                    } else if (
                                                        client.phonePrivate &&
                                                        client.phonePrivate !== "" &&
                                                        !client.phonePrivate.replace(/\s/g, "").match(phoneFormat)
                                                    ) {
                                                        setMissingInfo(
                                                            "Telefonnummer skal være mindst 8 cifre og må ikke indeholde specialtegn udover +"
                                                        );
                                                    } else if (client.CPR && client.CPR.length < 10) {
                                                        setMissingInfo(
                                                            "Fødselsdag er ikke udfyldt korrekt. Fødselsdato er obligatorisk at udfylde, løbenumre er valgfri."
                                                        );
                                                    } else {
                                                        setMissingInfo("Du mangler at opgive obligatorisk information");
                                                    }
                                                }
                                            }}
                                            className={classes.button}>
                                            {bookText}
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
            {activeStep === steps.length && (
                <Paper square elevation={0} className={classes.resetContainer}>
                    <Typography>Din booking er nu oprettet.</Typography>
                    <Button onClick={() => setActiveStep(0)} className={classes.button}>
                        Ny booking
                    </Button>
                </Paper>
            )}
        </div>
    );
};
